/**
 * Created by Mark on 17/04/2017.
 */

const getPath = function(){

    if(location.host.indexOf('localhost') > -1)
    {
       return "http://localhost.services.languagenut.com/"
    }

    if(location.host.indexOf('beta') > -1)
    {
        return 'https://service.languagenut.de/'
    }

    if(location.host.indexOf('staging') > -1)
    {
        return 'http://staging.services.languagenut.com'
    }

    return 'https://services.languagenut.com/'
}


const getBucket = function (){
    if(location.host.indexOf('localhost') > -1) return 'https://beta.assets.languagenut.com/'
    if(location.host.indexOf('beta') > -1) return 'https://beta.assets.languagenut.com/';
    return 'https://assets.languagenut.com/';
}

export default {
    BASE_URL: getPath(),
    GA_ID:'UA-86961577-1',
    APPLICATION_SYSTEM_UID : 2,
    TABLE_ASC :'asc',
    TABLE_DESC : 'desc',
    BUCKET: getBucket(),
    DEFAULT_LOCALE : 'en',
    SUPPORTED_LOCALES : ['af',
        'al',
        'als',
        'ar',
        'bn',
        'cn',
        'cs',
        'cy',
        'da',
        'de',
        'en',
        'es',
        'fa',
        'fe',
        'fi',
        'fr',
        'gd',
        'ht',
        'hz',
        'id',
        'it',
        'ja',
        'jis',
        'ko',
        'kr',
        'ku',
        'lt',
        'lv',
        'mi',
        'ms',
        'nl',
        'no',
        'pl',
        'po',
        'prs',
        'ps',
        'pt',
        'rj',
        'ru',
        'se',
        'so',
        'sq',
        'sv',
        'ti',
        'tr',
        'uk',
        'ur',
        'vi',
        'en',
        'es',
    ]
}



// WEBPACK FOOTER //
// ./src/constants/environment.js